import NotificationsTabContent from '../NotificationsTabContent';

/**
 * Notifications Customers
 */
const NotificationsCustomers = () => <NotificationsTabContent category="customers" />;

export default NotificationsCustomers;
